import React, { useEffect, useState } from "react";
import { Button, Select } from "antd";

import PredeterminationProceduresTable from "./PredeterminationProceduresTable";
import arrowDown from "../../../../assets/icons/arrow-down12.png";

export default function PredeterminationPatientSubTable({
  predeterminationOrPostPayment,
  handleApprovePostPayment,
  isApprovingPostPayment,
  setSelectedPaymentType,
  handleApproveInsurance,
  selectedPaymentType,
  setMarkedProcedures,
  selectedInsurance,
  approvedPatients,
  allPaymentTypes,
  insuranceStatus,
  allProcedures,
  isApproved,
  loading,
  record,
}) {
  const [emptyProcedureDropdowns, setEmptyProcedureDropdown] = useState({}); // To see what dropdown are empty to active or disable the approve button
  const [approvedProcedures, setApprovedProcedures] = useState({}); // To see what dropdown are empty to active or disable the approve button
  const [isOpenDropdowns, setOpenDropdowns] = useState([]); // For handling payment type dropdown arrow icon (arrow top/down)
  const [matchPaymentType, setMatchPaymentType] = useState(undefined);

  const paymentTypeOptions = allPaymentTypes.map((paymentType) => ({
    value: paymentType.id,
    label: paymentType.name ? paymentType.name : paymentType.description,
  }));

  useEffect(function () {
    // Check if all the patient's insurances have the same payment type
    const patientPaymentType = record.insurances.every((insurance) => insurance.payment_type === record.insurances[0].payment_type);
    const isThereAnyNullPaymentType = record.insurances.some((insurance) => insurance.payment_type === null || insurance.payment_type === undefined);

    if (patientPaymentType && !isThereAnyNullPaymentType) {
      const paymentTypeForThisPatient = allPaymentTypes.find((paymentType) => paymentType.id === record.insurances[0].payment_type);
      setMatchPaymentType(paymentTypeForThisPatient);
      setSelectedPaymentType(paymentTypeForThisPatient);
    }
  }, []);

  // Approve button logic for post-payment
  const isButtonDisabled =
    (predeterminationOrPostPayment === "post_payment" &&
      ((emptyProcedureDropdowns[record.id] && emptyProcedureDropdowns[record.id].length > 0) ||
        isApprovingPostPayment.includes(record.id) ||
        insuranceStatus === "approved" ||
        insuranceStatus === "accepted" ||
        isApproved ||
        approvedPatients.includes(record.id) ||
        record.insurances.every((insurance) => insurance.is_approved === true))) ||
    insuranceStatus === "approved" ||
    insuranceStatus === "accepted";

  console.log(insuranceStatus === "approved");
  console.log(insuranceStatus === "accepted");
  console.log(isApproved);
  console.log(approvedPatients.includes(record.id));
  console.log(record.insurances.every((insurance) => insurance.is_approved === true));

  // Determine button styles
  const isApprovedState =
    insuranceStatus === "approved" ||
    insuranceStatus === "accepted" ||
    isApproved ||
    approvedPatients.includes(record.id) ||
    record.insurances.every((insurance) => insurance.is_approved === true);

  function handleTogglePaymentTypeDropdown(patientID) {
    if (isOpenDropdowns.includes(patientID)) {
      setOpenDropdowns((prevIDs) => prevIDs.filter((id) => id !== patientID));
    } else {
      setOpenDropdowns((prevIDs) => [...prevIDs, patientID]);
    }
  }

  return (
    <div className="inner-area-insurance-procedure">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <p style={{ fontSize: 18, marginBottom: 0 }}>Insurance Details</p>

        {/* Payment type drop down */}
        {predeterminationOrPostPayment === "post_payment" && (
          <Select
            showSearch
            placeholder="Select Payment Type"
            optionFilterProp="label"
            options={paymentTypeOptions}
            className={`select-patient-id ${!Object.keys(selectedPaymentType).includes(record.id.toString()) && "no-transparent-background"}`}
            value={matchPaymentType && (matchPaymentType.name || matchPaymentType.description)}
            suffixIcon={
              <img
                style={{ width: 20, transform: `rotate(${isOpenDropdowns.includes(record.id) ? "180deg" : "0"})` }}
                src={arrowDown}
                alt="arrow-down"
              />
            }
            onChange={(value) => setSelectedPaymentType((prevPaymentTypes) => ({ ...prevPaymentTypes, [record.id]: value }))}
            onDropdownVisibleChange={() => handleTogglePaymentTypeDropdown(record.id)}
            disabled={isApproved || approvedPatients.includes(record.id) || record.insurances.every((insurance) => insurance.is_approved === true)}
            filterOption={(input, option) => {
              if (!input) return true;
              if (!option.label) return false;

              return (
                (option.label.props.name && option.label.props.name.toLowerCase().includes(input.toLowerCase())) ||
                (option.label.props.email && option.label.props.email.toLowerCase().includes(input.toLowerCase())) ||
                (option.label.props.phone && option.label.props.phone.toString().toLowerCase().includes(input.toLowerCase()))
              );
            }}
          />
        )}
      </div>
      {record.insurances && record.insurances.length > 0 ? (
        <>
          <PredeterminationProceduresTable
            predeterminationOrPostPayment={predeterminationOrPostPayment}
            disabledByApproved={selectedInsurance.status === "approved"}
            setEmptyProcedureDropdown={setEmptyProcedureDropdown}
            emptyProcedureDropdowns={emptyProcedureDropdowns}
            setApprovedProcedures={setApprovedProcedures}
            setMarkedProcedures={setMarkedProcedures}
            approvedProcedures={approvedProcedures}
            approvedPatients={approvedPatients}
            insurances={record.insurances}
            allProcedures={allProcedures}
            currentPatientID={record.id}
          />

          {/* Approved Button For Post Payment */}
          <div style={{ marginTop: 30, display: "flex" }}>
            <Button
              type="primary"
              onClick={() => (predeterminationOrPostPayment === "predetermination" ? handleApproveInsurance() : handleApprovePostPayment(record.id))}
              disabled={isButtonDisabled}
              style={{
                backgroundColor: isApprovedState ? "rgba(4, 201, 0, 0.1)" : isButtonDisabled ? "#F5F5F5" : "#6B43B5",
                color: isApprovedState ? "#04C900" : isButtonDisabled ? "#848696" : "white",
                border: isApprovedState ? "none" : isButtonDisabled ? "1px solid #d9d9d9" : "1px solid #6B43B5",
                padding: "20px 50px",
                marginLeft: "auto",
              }}
              className={`${isApproved ? "approved-button" : ""}`}
            >
              {loading || isApprovingPostPayment.includes(record.id)
                ? "Loading..."
                : (selectedInsurance.status === "processing" || selectedInsurance.status === "pending") &&
                  !record.insurances.every((insurance) => insurance.is_approved === true) &&
                  !approvedPatients.includes(record.id)
                ? "Approve All"
                : "Approved"}
            </Button>
          </div>
        </>
      ) : (
        <p>No insurance records found</p>
      )}
    </div>
  );
}
